export default __webpack_public_path__ + "static/media/Logo.37158c31.svg";